<!-- 查看历史讨论 -->
<template>
  <div class="el-DiscussionRecord">
    <el-row class="content_block mb30">
      <TitleInfo title="查看历史讨论" :titleImg="ct_b"></TitleInfo>
      <el-row class="p20" style="min-height: 320px;overflow: auto;">
        <el-row>
          <el-table
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column type="index" header-align="center" align="center" width="100" label="序号"></el-table-column>
            <el-table-column prop="teacherOpenCourseChatLogAddTime" header-align="center" align="center" label="发表日期" width="180" > </el-table-column>
            <el-table-column prop="chatContent" header-align="center" align="left" label="讨论内容">
              <template slot-scope="scope">
                <el-row v-html="scope.row.chatContent"></el-row>
              </template>
            </el-table-column>
            <el-table-column prop="schoolClassIdsText" header-align="center" align="center" label="可见班级" width="200">
              <template slot-scope="scope">
                <el-row>{{scope.row.schoolClassIdsText?scope.row.schoolClassIdsText:"全部"}}</el-row>
              </template>
            </el-table-column>
            <el-table-column prop="commentCount" header-align="center" align="center" label="讨论数" width="120"> </el-table-column>
            <el-table-column prop="user_" header-align="center" align="center" label="操作" width="180">
              <template slot-scope="scope">
                <el-link type="primary" class="mr20" :underline="false" @click="detailsInfo(scope.row)">详情</el-link>
                <el-link type="primary" :underline="false" @click="delInfo(scope.row)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limit"
              background
              :hide-on-single-page="true"
              layout="sizes, prev, pager, next,jumper"
              :total="total">
            </el-pagination>
          </div>
        </el-row>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo"; //页面头部
export default {
  name: "DiscussionRecord",
  components: {
  	TitleInfo,
  },
  data() {
    return {
      ct_b:require("../../images/course/ct_b@2x.png"),
      tableData:[],
      courseId:this.$route.query.courseId,
      total: 0,
      limit:10,
      page:1
    };
  },
  created() {
    this.getInfo();
  },
  mounted() {

  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){ //获取列表
      let param = {
        limit:this.limit,
        page:this.page,
        teacherOpenCourseId:this.courseId,
        chatLogSendTypePlural:"discuss"
      }
      this.$post("/api/teacherOpenCourseChatLog/treeList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    detailsInfo(item){ //详情
      this.$router.push({name:'TCourseHome',query:{teacherOpenCourseId:this.courseId,teacherOpenCourseChatLogId:item.teacherOpenCourseChatLogId}});
    },
    delInfo(item){ //删除
      this.$confirm('是否确定删除该信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("/jlw/teacherOpenCourseChatLog/delete.json",{ids:item.teacherOpenCourseChatLogId}).then((ret) =>{
          if(ret.code == 0){
            this.getInfo();
            this.$message({type: 'success',message: '删除成功!'});
          }else{
            this.$message({message: ret.msg,type: 'error'});
          }
        });
      }).catch(() => {
        this.$message({type: 'info',message: '已取消'});
      });
    }
  }
};
</script>
 <style  lang="less">
  .el-DiscussionRecord{
    padding: 20px 20px 0;
    .content_block{
      background-color: #ffffff;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/Teacher/DiscussionRecord.vue